var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Hmdgl),
      expression: "Hmdgl"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("黑名单管理")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("组织架构 ")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "220px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("城市 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "130px"
    },
    attrs: {
      "placeholder": _vm.postPlaceholder,
      "clearable": ""
    },
    model: {
      value: (_vm.condition.city_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "city_id", $$v)
      },
      expression: "condition.city_id"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("离职日期 ")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "130px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.condition.start_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "start_date", $$v)
      },
      expression: "condition.start_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("离职原因 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "130px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.is_signContract),
      callback: function($$v) {
        _vm.$set(_vm.condition, "is_signContract", $$v)
      },
      expression: "condition.is_signContract"
    }
  }, _vm._l((_vm.causeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("姓名 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "130px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.condition.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_name", $$v)
      },
      expression: "condition.staff_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "20px 50px",
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.yichu(null)
      }
    }
  }, [_vm._v("移除")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "220px"
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "margin-left": "-180px",
      "top": "100px"
    },
    attrs: {
      "fields": _vm.download_excel,
      "title": "黑名单",
      "name": "黑名单.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("\n                导表")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2% 3% 0 3%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "540"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "组织架构",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.$globals.group_name + "/" + scope.row.staff.range) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff.city_id",
      "align": "center",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff.post_name",
      "align": "center",
      "label": "职位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff.staff_name",
      "align": "center",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff.staff_card",
      "align": "center",
      "label": "身份证号码",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff.staff_telephone",
      "align": "center",
      "label": "手机号",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dictionaries_time",
      "align": "center",
      "label": "离职日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dictionaries_data",
      "align": "center",
      "label": "离职原因",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlement_effective",
      "align": "center",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/移除.png")
          },
          on: {
            "click": function($event) {
              return _vm.yichu(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])]), _vm._v(" "), (_vm.dialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "移除",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "close-on-click-modal": false,
      "center": true,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('yichu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showyi),
      expression: "showyi"
    }],
    ref: "yichus"
  })], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473c57d6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Hmdgl/Hmdgl.vue
// module id = null
// module chunks = 